import { RadioButton } from 'components/Shared/Form';
import {
  BlueSectionContainer,
  ErrorContainer,
  RadioBtnContainer
} from '../SectionContainer/SectionContainer';
import { rm } from 'utils';
import styles from './styles.scss';
import { useState } from 'react';
import { CustomerContact as CustomerContactModel } from 'models/CustomerContact';
import { getContactOptions, getInputFieldWithRules } from './utils';
import { ChangeContactInfoEnum } from 'models/ChangeContactInfoEnum';

type CustomerContactProps = {
  onChange: (contact: CustomerContactModel) => void;
  error?: string;
  contact: CustomerContactModel;
  addressAlreadyAdded?: boolean;
};

export const CustomerContact = ({
  onChange,
  error,
  contact,
  addressAlreadyAdded = false
}: CustomerContactProps) => {
  const [input, setInput] = useState('');
  const [selectedContactOption, setSelectedContactOption] = useState(
    contact.preferredContactMethod
  );
  const [contactChangeMethod, setContactChangeMethod] = useState<number>(
    ChangeContactInfoEnum.UseOrderData
  );
  const isChecked = (value: string | number, baseValue: string | number) => {
    return value === baseValue;
  };

  const updateContactInformation = (updates: Partial<CustomerContactModel>) => {
    onChange({
      ...contact,
      ...updates
    });
  };
  const handleSelectContactOption = (val: string) => {
    setSelectedContactOption(val);
    updateContactInformation({
      preferredContactMethod: val
    });
  };

  const handleContactMethodChange = (value: number) => {
    setContactChangeMethod(value);
    updateContactInformation({
      changeContactInfo: value
    });
  };

  const handleInputChange = (val: string) => {
    setInput(val);
    updateContactInformation({
      newContactInfo: val
    });
  };

  return (
    <>
      <BlueSectionContainer error={error}>
        <strong>{rm('customerService_form_contact_header')}</strong>
        <p>{rm('customerService_form_contact_disclaimer')}</p>
        <RadioBtnContainer>
          {getContactOptions().map(item => {
            return (
              <RadioButton
                key={item.id}
                value={item.value}
                label={item.label}
                name="contact-option-radio-button"
                checked={isChecked(item.value, selectedContactOption)}
                onChange={val => handleSelectContactOption(val.toString())}
              />
            );
          })}
        </RadioBtnContainer>
        {selectedContactOption && !addressAlreadyAdded && (
          <>
            <strong>{rm('customerService_form_contact_change')}</strong>
            <div className={styles.options}>
              <RadioButton
                value={ChangeContactInfoEnum.UseOrderData}
                label={rm('customerService_form_contact_use_order_data')}
                name="contact-option-radio-button-use-order-data"
                checked={isChecked(ChangeContactInfoEnum.UseOrderData, contactChangeMethod)}
                onChange={val => handleContactMethodChange(Number(val))}
              />
              <RadioButton
                value={ChangeContactInfoEnum.InputNewContact}
                label={getInputFieldWithRules({
                  option: selectedContactOption,
                  input,
                  setInput: handleInputChange,
                  setChecked: handleContactMethodChange
                })}
                name="contact-option-radio-button-use-order-data"
                checked={isChecked(ChangeContactInfoEnum.InputNewContact, contactChangeMethod)}
                onChange={val => handleContactMethodChange(Number(val))}
              />
            </div>
          </>
        )}
      </BlueSectionContainer>
      {error && <ErrorContainer>{error}</ErrorContainer>}
    </>
  );
};
